import { useTranslation } from 'react-i18next';
import { SettingsHeader } from '../../../../components/layout/settings-header/settings-header';
import { BookrWpOptions, BookrWpOptionsSettings } from '../../../../core/models/bookr-wp-options';
import { SettingsRow } from '../settings-row/settings-row';
import { InputNumber } from 'antd';
import { useEffect, useState } from 'react';

type GeneralSettingsProps = {
	bookrWpOptions?: BookrWpOptions;
	onClickSave: () => void;
	onChange: (bookrWpOptions: BookrWpOptions) => void;
};

export const GeneralSettings: React.FC<GeneralSettingsProps> = ({ bookrWpOptions, onClickSave, onChange }) => {
	const { t } = useTranslation();
	const [settings, setSettings] = useState<BookrWpOptionsSettings>({
		bookingDaysAhead: window.bookrPluginData.settings.bookingDaysAhead,
	});

	useEffect(() => {
		if (!bookrWpOptions) return;

		const updateBookrOptions: BookrWpOptions = {
			...bookrWpOptions,
			settings: {
				bookingDaysAhead: settings.bookingDaysAhead,
			},
		};

		onChange(updateBookrOptions);
	}, [settings]);

	function onChangeBookingDays(value: number | null) {
		if (!value) return;

		setSettings({
			bookingDaysAhead: value,
		});
	}

	return (
		<>
			<SettingsHeader title={t('backEnd.settings.general.title')} onClickSave={onClickSave} />

			<SettingsRow title={t('backEnd.settings.general.bookingDaysAhead')}>
				<InputNumber min={1} defaultValue={30} value={settings.bookingDaysAhead} onChange={onChangeBookingDays} />
			</SettingsRow>
		</>
	);
};
